import _classCallCheck from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.concat.js";
var _Vue = null;

var install = function install(Vue) {
  // 防止多次use
  if (Vue && _Vue !== Vue) {
    _Vue = Vue;

    var Bus = /*#__PURE__*/function () {
      function Bus() {
        _classCallCheck(this, Bus);

        // 绑定指针
        this._vueIns = new Vue();
      }

      _createClass(Bus, [{
        key: "emit",
        value: function emit(event) {
          var _this$_vueIns;

          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          (_this$_vueIns = this._vueIns).$emit.apply(_this$_vueIns, [event].concat(args));
        }
      }, {
        key: "on",
        value: function on(event, cb) {
          this._vueIns.$on(event, cb);
        }
      }, {
        key: "off",
        value: function off(event, cb) {
          this._vueIns.$off(event, cb);
        }
      }]);

      return Bus;
    }();

    Vue.prototype.Bus = new Bus();
  }
};

export default install;